import { createAction, handleActions } from 'redux-actions'
import client from 'common/util/http'
import { loadStart, loadFinish, loadError } from 'common/redux/root'

const LOAD = 'lead/LOAD'

const load = createAction(LOAD)

const defaultErrorHandler = dispatch => error => {
  dispatch(loadError(error))
  return Promise.reject(error)
}

const defaultLoadHandler = dispatch => response => {
    dispatch(load(response))
    dispatch(loadFinish())
    return Promise.resolve(response)
}

export function updateLeadPreferences(lead_hash, preferences, loan_officer_whitelist) {
  return dispatch => {
    dispatch(loadStart())

    // TODO: remove is_new_financing after client refresh
    return client.post('update_lead_preferences', { data: {
            lead_hash: lead_hash,
            ...preferences,
            is_new_financing: true,
            loan_officer_whitelist: loan_officer_whitelist,
        }
    })
    .then(dispatch(defaultLoadHandler))
    .catch(dispatch(defaultErrorHandler))
  }
}

const initialState = {
  calls: {},
  leadFlags: {},
  zipcode: {}
}

export default handleActions({
    [LOAD]: (state, { payload }) => (Object.assign({}, state, {...payload})),
}, initialState)
